import { TypeCampaignEnum } from '@/types';
import type { FlowOperatorMetadata, ValidationResult } from '@/types/flow-types';
import { canDeleteTrigger } from '@/components/flows/operators/registry';

export interface AbandonCartData {
  event: string;
}

export function createDefaultData(): AbandonCartData {
  return {
    event: 'abandon_cart',
  };
}

const AbandonCart: FlowOperatorMetadata<AbandonCartData> = {
  id: 'boxabandonpanier',
  kind: 'trigger',
  label: 'flows.operators.abandonCart.label',
  icon: 'fa-cart-shopping',
  hasConfiguration: false,
  availableIn: [],
  hidden: true,

  incompatibilities: {
    [TypeCampaignEnum.AUTOMATION]: {
      nextOperators: [
        'boxabandonpanier', 'boxsitepasstime', 'boxquitsite',
        'boxperiodiclaunching', 'boxscrollpage', 'boxstatuscommand',
        'boxcustomjs', 'boxregisteronsite', 'boxsubscribetonewsletter',
        'boxsendemail', 'boxsendsms', 'boxdisplayfreepopup',
        'boxdisplayfreemodel', 'boxsendfbmessenger', 'boxsendpushnotification',
        'boxfiltre_2', 'openemail', 'clicklink',
        'boxvisitpage', 'boxtriggerinternalevent', 'boxsendrcs', 'boxsendwhatsapp',
      ],
    },
  },

  defaultData: createDefaultData,

  outputs: () => 1,

  canBeDeleted(operatorId: string, flow: any): Promise<boolean | string> {
    return canDeleteTrigger(flow, operatorId);
  },
};

export default AbandonCart;
